export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQYV2PIiyn4DwAEsAI6XLbFUQAAAABJRU5ErkJggg=="